// extracted by mini-css-extract-plugin
export default {"container":"ui_container__UTZ-U","spinnerWrapper":"ui_spinnerWrapper__v6YuV"};